import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, MapPin, Users, Clock, Briefcase, Building } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const SeminaireMarcoPolo = () => {
  const { language } = useLanguage();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)' }}>
      {/* Hero Section */}
      <section style={{
        position: 'relative',
        padding: '80px 40px',
        background: 'linear-gradient(135deg, rgba(44, 95, 125, 0.08) 0%, rgba(255, 254, 242, 1) 100%)',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <Link to="/member/seminaires" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '24px',
            color: 'var(--text-secondary)',
            textDecoration: 'none',
            fontSize: '14px'
          }}>
            <ArrowLeft size={16} />
            {language === 'fr' ? 'Retour aux séminaires' : 'Back to seminars'}
          </Link>
          
          <div style={{
            display: 'inline-block',
            padding: '6px 12px',
            background: '#2c5f7d',
            color: 'var(--bg-primary)',
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            marginBottom: '16px'
          }}>
            {language === 'fr' ? 'Séminaire Privé' : 'Private Seminar'}
          </div>

          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Marco Polo Business Vision
          </h1>
          <h2 className="hero-medium" style={{ 
            marginBottom: '24px',
            color: 'var(--text-secondary)'
          }}>
            The Future of IT Solutions
          </h2>
          
          <div style={{
            display: 'flex',
            gap: '24px',
            flexWrap: 'wrap',
            marginBottom: '24px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Calendar size={20} />
              <span className="body-large">15 Janvier 2026</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MapPin size={20} />
              <span className="body-large">Paris - Hôtel Alfred Sommier</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Users size={20} />
              <span className="body-large">40-45 {language === 'fr' ? 'participants' : 'participants'}</span>
            </div>
          </div>

          <p className="body-large" style={{ 
            lineHeight: 1.8,
            color: 'var(--text-secondary)'
          }}>
            {language === 'fr'
              ? "Séminaire privé réservé aux dirigeants d'entreprises IT et aux éditeurs informatiques. Inauguration de la 1ère édition de séminaires Marco Polo Business Vision (MPBV)."
              : "Private seminar reserved for IT company executives and software publishers. Inauguration of the 1st edition of Marco Polo Business Vision (MPBV) seminars."}
          </p>
        </div>
      </section>

      {/* Intervenants */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '48px', textAlign: 'center' }}>
            {language === 'fr' ? 'Les Grands Invités' : 'Distinguished Guests'}
          </h2>
          
          <div style={{
            display: 'grid',
            gap: '32px'
          }}>
            {/* Sara TIAN */}
            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Briefcase size={24} color="#2c5f7d" />
                <h3 className="heading-1" style={{ color: '#2c5f7d' }}>
                  Sara TIAN
                </h3>
              </div>
              <p className="body-regular" style={{ 
                fontWeight: 600, 
                marginBottom: '12px',
                color: 'var(--text-primary)'
              }}>
                {language === 'fr'
                  ? 'Vice-Présidente de JP Morgan China'
                  : 'Vice President of JP Morgan China'}
              </p>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Grand Investisseur'
                      : 'Major Investor'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Investisseur de la Société « Ou Xin Lu Information Technology »'
                      : 'Investor in "Ou Xin Lu Information Technology" Company'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Dix ans d\'expériences sur les investissements en Asie'
                      : 'Ten years of experience in Asian investments'}
                  </span>
                </li>
              </ul>
            </div>

            {/* Yue JIN */}
            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Briefcase size={24} color="#2c5f7d" />
                <h3 className="heading-1" style={{ color: '#2c5f7d' }}>
                  Yue JIN
                </h3>
              </div>
              <p className="body-regular" style={{ 
                fontWeight: 600, 
                marginBottom: '12px',
                color: 'var(--text-primary)'
              }}>
                {language === 'fr'
                  ? 'Directrice générale du comité gouvernemental « Specialized in special new »'
                  : 'General Director of the "Specialized in special new" government committee'}
              </p>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Experte de l\'exploitation et de la politique Chinoise'
                      : 'Expert in Chinese operations and policy'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Directrice générale de la Société « China Corporate United Pavilion Group »'
                      : 'General Director of "China Corporate United Pavilion Group"'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? '20 ans d\'expériences sur les affaires entre gouvernements et business'
                      : '20 years of experience in government-business affairs'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Jury décisionnaire gouvernemental de la délivrance des avantages pour les sociétés'
                      : 'Government decision-making jury for granting company benefits'}
                  </span>
                </li>
              </ul>
            </div>

            {/* Gérald KARSENTI */}
            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              border: '1px solid var(--border-light)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Briefcase size={24} color="#2c5f7d" />
                <h3 className="heading-1" style={{ color: '#2c5f7d' }}>
                  Gérald KARSENTI
                </h3>
              </div>
              <p className="body-regular" style={{ 
                fontWeight: 600, 
                marginBottom: '12px',
                color: 'var(--text-primary)'
              }}>
                PDG SAP France
              </p>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr'
                      ? 'Personnalité française du monde des affaires'
                      : 'French business personality'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr' ? 'Conférencier et écrivain' : 'Speaker and writer'}
                  </span>
                </li>
                <li style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                  <span style={{ color: '#2c5f7d', marginTop: '2px' }}>•</span>
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {language === 'fr' ? 'Professeur affilié à HEC' : 'Affiliated Professor at HEC'}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Programme */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '48px', textAlign: 'center' }}>
            {language === 'fr' ? 'Programme de la Conférence' : 'Conference Program'}
          </h2>
          
          <div style={{
            display: 'grid',
            gap: '0',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-light)'
          }}>
            {[
              {
                time: '18h00',
                title: language === 'fr' ? 'Accueil des participants' : 'Welcome participants',
                speaker: 'Wilfrid - Animateur'
              },
              {
                time: '18h10',
                title: language === 'fr' ? 'Discours de lancement' : 'Opening speech',
                description: language === 'fr' 
                  ? 'Présentation globale : club, avantages, adhésion au club H&G "MPBV"'
                  : 'Global presentation: club, benefits, H&G "MPBV" membership',
                speaker: 'Jérôme-Henri',
                duration: '20 min'
              },
              {
                time: '18h30',
                title: language === 'fr' ? 'Discours de bienvenue' : 'Welcome speech',
                speaker: language === 'fr' ? 'Directeur de l\'Hôtel Alfred Sommier' : 'Director of Hotel Alfred Sommier',
                duration: '5 min'
              },
              {
                time: '18h35',
                title: language === 'fr' 
                  ? 'Présentation des avantages d\'installation et de subvention à Shanghai' 
                  : 'Presentation of installation and subsidy benefits in Shanghai',
                speaker: 'Yue JIN (en vidéo)',
                duration: '15 min'
              },
              {
                time: '18h50',
                title: language === 'fr' 
                  ? 'Comment jouer le jeu du marché informatique en Chine' 
                  : 'How to play the IT market game in China',
                speaker: 'Sara TIAN (VP JP Morgan China)',
                duration: '15 min',
                lang: 'English'
              },
              {
                time: '19h05',
                title: language === 'fr' ? 'Constituer une équipe gagnante' : 'Building a winning team',
                speaker: 'Gérald Karsenti (PDG SAP France)',
                duration: '15 min'
              },
              {
                time: '19h20',
                title: language === 'fr' ? 'Table ronde' : 'Round table',
                description: language === 'fr'
                  ? 'Échange entre Gérald Karsenti et Sara TIAN'
                  : 'Exchange between Gérald Karsenti and Sara TIAN',
                duration: '20 min',
                lang: 'English'
              },
              {
                time: '19h40',
                title: language === 'fr' ? 'Tirage au sort' : 'Prize draw',
                description: language === 'fr' 
                  ? 'Livre de Gérald Karsenti dédicacé' 
                  : 'Signed book by Gérald Karsenti'
              },
              {
                time: '20h00',
                title: language === 'fr' ? 'Cocktail Dînatoire & Networking' : 'Cocktail Dinner & Networking',
                description: language === 'fr'
                  ? 'Échange et enrichissement du réseau, animation musicale'
                  : 'Exchange and network enrichment, musical entertainment'
              }
            ].map((item, index) => (
              <div key={index} style={{
                padding: '24px 32px',
                borderBottom: index < 8 ? '1px solid var(--border-light)' : 'none',
                display: 'flex',
                gap: '32px',
                alignItems: 'flex-start'
              }}>
                <div style={{
                  minWidth: '70px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <Clock size={16} color="var(--text-secondary)" />
                  <span className="body-regular" style={{ fontWeight: 600 }}>
                    {item.time}
                  </span>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 className="heading-2" style={{ marginBottom: '4px' }}>
                    {item.title}
                  </h3>
                  {item.description && (
                    <p className="body-regular" style={{ 
                      color: 'var(--text-secondary)',
                      marginBottom: '8px'
                    }}>
                      {item.description}
                    </p>
                  )}
                  {item.speaker && (
                    <p className="body-small" style={{ 
                      color: 'var(--text-primary)',
                      fontWeight: 600
                    }}>
                      {item.speaker}
                      {item.duration && ` • ${item.duration}`}
                      {item.lang && ` • ${item.lang}`}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hôtel Alfred Sommier */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px', justifyContent: 'center' }}>
            <Building size={32} color="#2c5f7d" />
            <h2 className="hero-medium">
              Hôtel Alfred Sommier
            </h2>
          </div>
          
          <p className="body-regular" style={{ 
            lineHeight: 1.8, 
            color: 'var(--text-secondary)',
            marginBottom: '16px'
          }}>
            {language === 'fr'
              ? "Construit en 1860, l'hôtel particulier d'Alfred Sommier, industriel du sucre, vient d'être restauré par un descendant de la famille en hôtel de luxe."
              : "Built in 1860, the private mansion of Alfred Sommier, sugar industrialist, has just been restored by a family descendant into a luxury hotel."}
          </p>
          <p className="body-regular" style={{ 
            lineHeight: 1.8, 
            color: 'var(--text-secondary)',
            marginBottom: '16px'
          }}>
            {language === 'fr'
              ? "Conservant l'âme d'une demeure familiale, il offre au cœur de Paris 80 chambres dont 17 suites, des salons historiques, une salle de fitness ainsi qu'un restaurant et un bar ouvert sur un jardin privé."
              : "Preserving the soul of a family home, it offers in the heart of Paris 80 rooms including 17 suites, historic lounges, a fitness room as well as a restaurant and bar opening onto a private garden."}
          </p>
          <p className="body-regular" style={{ 
            lineHeight: 1.8, 
            color: 'var(--text-secondary)'
          }}>
            {language === 'fr'
              ? "En entrant dans l'hôtel apparaît une succession de pièces de réceptions spacieuses et lumineuses. Un même damier de marbre blanc et grenat couvre le sol et accentue l'effet de perspective. Aux extrémités, les deux escaliers en marbre sont majestueux."
              : "Upon entering the hotel, a succession of spacious and bright reception rooms appears. The same white and garnet marble checkerboard covers the floor and accentuates the perspective effect. At the ends, the two marble staircases are majestic."}
          </p>
        </div>
      </section>

      {/* Objectifs du Club */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '48px', textAlign: 'center' }}>
            {language === 'fr' 
              ? 'Les Objectifs du Club Marco Polo Business Vision' 
              : 'Marco Polo Business Vision Club Objectives'}
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px'
          }}>
            {[
              {
                title: language === 'fr' ? 'Partage d\'Information' : 'Information Sharing',
                description: language === 'fr'
                  ? 'Informations à jour et « d\'initiés » sur le marché Asiatique'
                  : 'Up-to-date and "insider" information on the Asian market'
              },
              {
                title: language === 'fr' ? 'Mise en Relation' : 'Networking',
                description: language === 'fr'
                  ? 'Accès à la haute qualité en mode porte fermée'
                  : 'Access to high quality in closed-door mode'
              },
              {
                title: language === 'fr' ? 'Formation & Consulting' : 'Training & Consulting',
                description: language === 'fr'
                  ? 'Professionnel et pragmatique pour les opportunités sur le marché asiatique'
                  : 'Professional and pragmatic for opportunities in the Asian market'
              },
              {
                title: language === 'fr' ? 'Ressources Premium' : 'Premium Resources',
                description: language === 'fr'
                  ? 'Accès aux ressources de haut niveau'
                  : 'Access to high-level resources'
              },
              {
                title: language === 'fr' ? 'Voyages & Rencontres' : 'Travel & Meetings',
                description: language === 'fr'
                  ? 'Grands voyages et rencontres business'
                  : 'Major business travel and meetings'
              }
            ].map((objectif, index) => (
              <div key={index} style={{
                padding: '28px',
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-light)',
                textAlign: 'center'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  {objectif.title}
                </h3>
                <p className="body-regular" style={{ 
                  color: 'var(--text-secondary)',
                  lineHeight: 1.7
                }}>
                  {objectif.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ maxWidth: '600px', textAlign: 'center' }}>
          <h3 className="heading-1" style={{ marginBottom: '16px' }}>
            {language === 'fr' ? 'Inscription' : 'Registration'}
          </h3>
          <p className="body-large" style={{ marginBottom: '24px', lineHeight: 1.7 }}>
            {language === 'fr'
              ? 'Pour participer à ce séminaire exclusif, contactez Jérôme-Henri'
              : 'To participate in this exclusive seminar, contact Jérôme-Henri'}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center' }}>
            <a href="tel:+33641664258" className="btn-primary" style={{ textDecoration: 'none' }}>
              {language === 'fr' ? 'Appeler : 06 41 66 42 58' : 'Call: 06 41 66 42 58'}
            </a>
            <a href="mailto:jerome.serre@henry-and-gaby.com" className="btn-secondary" style={{ textDecoration: 'none' }}>
              jerome.serre@henry-and-gaby.com
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SeminaireMarcoPolo;
